import { gql } from '@apollo/client';
import { apolloClientDS } from '../../../apollo';

export const getReplInStockPctQuery = (type, threshold, anomalyChange) => {
	const payload = `query InventoryHealth($startDate: String!, $endDate: String!, $id: [String], $channel: [String]) {
    inventoryHealth(
      input: {
        attributeFilters: [
          { attribute: "${type}", name: "id", values: $id },
          { name: "flag", values: ["${anomalyChange}"] },
          { name: "instock_percent_threshold", values: ["${threshold}"] },
          { name: "channel", values: $channel }
        ],
        timeFilters: [
          { startDate: $startDate , endDate: $endDate }
        ]
      }
    ) {
      itemOosCnt
      totalSalesImpact
      causes {
        edges {
          node {
            potentialSalesImpact
            dimensions {
              wmItemNbr
              wmItemNm
            }
          }
        }
      }
    }
  }`;
	return payload;
};

export const generateReplInStockPctQuery = async (payload) => {
	const type = payload.type;
	const threshold = payload.threshold;
	const anomalyChange = payload.anomalyChange;

	const replInStockPctReq = {
		startDate: payload.startDate,
		endDate: payload.endDate,
		channel: ['STORE'],
		id: payload.id,
	};

	const queryStr = gql`
		${getReplInStockPctQuery(type, threshold, anomalyChange)}
	`;

	try {
		return await apolloClientDS.query({
			query: queryStr,
			context: {
				headers: {
					'x-Apollo-operation-name': 'anomaly',
				},
			},
			variables: replInStockPctReq,
		});
	} catch (error) {
		console.log(error);
	}
};
